





















import { Component, Prop, Vue } from 'vue-property-decorator'
import Acomodacoes from '@finx/web-repository/src/constants/Acomodacoes'

@Component

export default class ComponentProducaoAcomodacao extends Vue {
  @Prop(Object) producao
  @Prop(Boolean) isEdit

  acomodacoes: Array<any> = []

  mounted() {
    this.getAcomodacoes()
  }

  getAcomodacoes() {
    this.acomodacoes = Acomodacoes
  }
}
